import { ChangeDetectionStrategy, Component, TemplateRef, ViewEncapsulation, contentChild, forwardRef, model } from "@angular/core";
import { Wrapper } from "../wrapper.interface";
import { CommonModule } from "@angular/common";
import { WRAPPER_TOKEN } from "../wrapper.tokens";
import { HorizontalContainerConfig } from "./horizontal-container.config";

@Component({
    selector:        'v-horizontal-container',
    templateUrl:     './horizontal-container.component.haml',
    styleUrls:       ['./horizontal-container.component.sass'],
    encapsulation:   ViewEncapsulation.None,
    providers:       [{ provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VHorizontalContainerComponent) }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule]
})
export class VHorizontalContainerComponent<T extends unknown> extends Wrapper<HorizontalContainerConfig>{
    protected readonly _baseConfig: never;
    // protected _baseConfig: HorizontalContainerConfig = HorizontalContainerConfig.baseTheme.Default;

    itemTemplate = contentChild<TemplateRef<unknown>>('item');
    value = model<T[]>([]);
    // cValue = computed(() => Array(100).fill(this.value()).flat());
}